import React, { FC } from "react";

const NotFoundPage: FC = () => {
	return (
		<h1>404: Not found</h1>
	);
};

export default NotFoundPage;